import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { RangeValueDTO } from "../../../../../datasources/api-client/data-contracts";
import { getHeatColor } from "../../utils";

interface Props {
	title?: string;
	scale: RangeValueDTO[] | undefined;
	baseColor: string;
}

/**
 * Renders a map legend with Scale data
 * Made to be used among with a map HeatLayer to help the user
 * make sense of the displayed data
 * @param title title of the legend
 * @param scale scale that the legend will be based on
 * @param baseColor base color of the HeatLayer used to re-calculate scale colors
 * @returns
 */
const ScaleLegend: FC<Props> = ({ title, scale, baseColor }) => {
	// if a title is specified, create it
	const titleTypography = title && (
		<Typography variant="subtitle1" fontWeight={"bold"} color="primary" mb={1}>
			{title}
		</Typography>
	);

	return (
		<Stack alignItems={"center"}>
			{titleTypography}
			<Stack direction={"row"} spacing={1}>
				{scale?.map((range, index) => (
					<Stack alignItems={"center"} spacing={1} key={index}>
						<Box
							sx={{
								width: "70px",
								height: "12px",
								backgroundColor: getHeatColor(range.min, scale, baseColor),
								borderRadius: "8px",
							}}
						/>
						<Typography variant={"caption"}>{range.min}</Typography>
					</Stack>
				))}
			</Stack>
		</Stack>
	);
};

export default ScaleLegend;
